var _rect, _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCompleteProfileContent = function SvgCompleteProfileContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#966BDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.305 11.14h-12.91c-1.188 0-2.15.96-2.15 2.145v7.506c0 1.184.962 2.144 2.15 2.144h12.91c1.188 0 2.152-.96 2.152-2.144v-7.506a2.148 2.148 0 0 0-2.152-2.145Z",
    fill: "url(#complete-profile-content_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7 17.038c-.571 0-1.118.226-1.522.628-.404.402-.63.947-.63 1.516v7.506c0 .569.226 1.114.63 1.516.403.403.95.628 1.521.628h12.91c.57 0 1.118-.225 1.521-.628a2.14 2.14 0 0 0 .63-1.516v-7.506c0-.569-.226-1.114-.63-1.516a2.155 2.155 0 0 0-1.521-.628h-12.91Zm12.909 5.897h-4.841v1.072h4.84v-1.072Zm-6.455-2.68h6.455v1.072h-6.455v-1.073Zm6.455 5.36h-4.841v1.073h4.84v-1.072Zm-8.069-4.824c0 .426-.17.835-.472 1.137a1.616 1.616 0 0 1-2.755-1.137c0-.427.17-.836.473-1.138a1.617 1.617 0 0 1 2.282 0c.302.302.472.711.472 1.138Zm1.076 6.433c.595 0 1.092-.49.924-1.058a3.754 3.754 0 0 0-1.357-1.946 3.774 3.774 0 0 0-5.87 1.946c-.167.568.33 1.058.924 1.058h5.38Z",
    fill: "url(#complete-profile-content_svg__b)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.457 17.038H15.7c-.57 0-1.117.226-1.521.628-.404.402-.63.947-.63 1.516v3.753h10.758c.477 0 .94-.158 1.317-.45.377-.29.647-.698.767-1.158h-4.236v-1.073h4.303v-3.216Zm-7.53 5.36a1.619 1.619 0 0 0 1.49-.992 1.604 1.604 0 0 0-.873-2.101 1.617 1.617 0 0 0-1.758.348 1.606 1.606 0 0 0 1.14 2.746Z",
    fill: "url(#complete-profile-content_svg__c)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "complete-profile-content_svg__a",
    x1: 17.85,
    y1: 11.14,
    x2: 17.85,
    y2: 22.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "complete-profile-content_svg__b",
    x1: 22.154,
    y1: 17.038,
    x2: 22.154,
    y2: 28.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "complete-profile-content_svg__c",
    x1: 20.003,
    y1: 17.038,
    x2: 20.003,
    y2: 22.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  })))));
};

export default SvgCompleteProfileContent;